import ReactNativeBlobUtil from 'react-native-blob-util';
import Share from 'react-native-share';
import { isWeb } from './platform';

export const toBase64 = (file: Blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const downloadFile = async ({ fileUrl, fileName, fileType = 'text/plain' }: { fileUrl: string; fileName: string; fileType?: string }) => {
  if (!fileUrl || !fileName) {
    return console.error('File URL and File Name are required');
  }

  if (typeof fileUrl !== 'string' || typeof fileName !== 'string') {
    return console.error('Invalid File URL or File Name');
  }

  const handleWebShare = async () => {
    const response = await fetch(fileUrl, { ignoreInterceptor: 'true' } as RequestInit);
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    link.remove();
  };

  const handleNativeShare = async () => {
    try {
      let imagePath = null;
      const resp = await ReactNativeBlobUtil.config({ fileCache: true }).fetch('GET', fileUrl, { ignoreInterceptor: 'true' } as RequestInit);
      imagePath = resp.path();
      const base64Data = await resp.readFile('base64');
      const base64Url = `data:${fileType};base64,${base64Data}`;
      await Share.open({ url: base64Url });
      if (imagePath) {
        await ReactNativeBlobUtil.fs.unlink(imagePath);
      }
    } catch (e) {
      console.log(e);
    }
  };

  if (isWeb) {
    await handleWebShare();
  } else {
    await handleNativeShare();
  }
};

export const download = ({
  images,
  selectedIndex,
  downloadUrl: _downloadUrl,
  fileName: _fileName,
}: {
  images?: Array<{ downloadUrl?: string; fileName?: string }>;
  selectedIndex: number;
  downloadUrl?: string;
  fileName?: string;
}) => {
  const downloadUrl = _downloadUrl || images?.[selectedIndex]?.downloadUrl || null;
  const fileName = _fileName || images?.[selectedIndex]?.fileName || null;
  if (!downloadUrl || !fileName) return;

  fetch(downloadUrl, { ignoreInterceptor: 'true' } as RequestInit)
    .then((response) => response.blob())
    .then((blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    })
    .catch(console.error);
};

export const shareFile = ({
  setLoading,
  images,
  selectedIndex,
  url: _url,
}: {
  setLoading: (loading: boolean) => void;
  images?: Array<{ url?: string }>;
  selectedIndex: number;
  url?: string;
}) => {
  setLoading(true);
  const url = _url ?? images?.[selectedIndex]?.url;
  if (!url) {
    setLoading(false);
    return;
  }

  let imagePath = null;
  ReactNativeBlobUtil.config({
    fileCache: true,
  })
    .fetch('GET', url, { ignoreInterceptor: 'true' } as RequestInit)
    .then((resp) => {
      imagePath = resp.path();
      return resp.readFile('base64');
    })
    .then(async (base64Data: string) => {
      const base64Url = `data:image/png;base64,` + base64Data;
      await Share.open({ url: base64Url });
      setLoading(false);
      return ReactNativeBlobUtil.fs.unlink(imagePath);
    })
    .catch((e) => {
      setLoading(false);
    });
};
